export default "__VITE_ASSET__BYjpVdyY__"